module.exports = __webpack_public_path__ + "7e7355356131af04de8c1a88a566c9f0.svg";